import { render } from "./TabSelector.vue?vue&type=template&id=33be5546"
import script from "./TabSelector.vue?vue&type=script&lang=js"
export * from "./TabSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__